// @@match logic
require('./_fix-re-wks')('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/core-js/modules/es6.regexp.match.js
// module id = ../../../../core-js/modules/es6.regexp.match.js
// module chunks = 0